<!-- Services Section -->
<section class="flex flex-col items-center gap-12">
  <app-section-header
    icon="@tui.briefcase"
    subtitle="Development Services"
    title="Comprehensive Mobile Development Services"
    description="OpenForge offers end-to-end mobile app development services perfectly integrated with the Capawesome ecosystem"
  />

  <div class="grid w-full grid-cols-1 gap-8 sm:grid-cols-2">
    <div
      class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <h3 class="text-xl font-bold">Development & Integration</h3>
      </div>
      <ul class="space-y-3">
        <li class="flex items-start text-pretty text-lg">
          <tui-icon icon="@tui.check" class="mr-2 mt-0.5 flex-shrink-0" />
          Full-cycle Capacitor app development
        </li>
        <li class="flex items-start text-pretty text-lg">
          <tui-icon icon="@tui.check" class="mr-2 mt-0.5 flex-shrink-0" />
          Capawesome Cloud integration and optimization
        </li>
        <li class="flex items-start text-pretty text-lg">
          <tui-icon icon="@tui.check" class="mr-2 mt-0.5 flex-shrink-0" />
          Custom plugin development and implementation
        </li>
        <li class="flex items-start text-pretty text-lg">
          <tui-icon icon="@tui.check" class="mr-2 mt-0.5 flex-shrink-0" />
          Cross-platform iOS and Android deployment
        </li>
      </ul>
    </div>

    <div
      class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <h3 class="text-xl font-bold">Design & Strategy</h3>
      </div>
      <ul class="space-y-3">
        <li class="flex items-start text-pretty text-lg">
          <tui-icon icon="@tui.check" class="mr-2 mt-0.5 flex-shrink-0" />
          UX/UI design and user experience optimization
        </li>
        <li class="flex items-start text-pretty text-lg">
          <tui-icon icon="@tui.check" class="mr-2 mt-0.5 flex-shrink-0" />
          Mobile app marketing and positioning
        </li>
        <li class="flex items-start text-pretty text-lg">
          <tui-icon icon="@tui.check" class="mr-2 mt-0.5 flex-shrink-0" />
          App store optimization (ASO)
        </li>
        <li class="flex items-start text-pretty text-lg">
          <tui-icon icon="@tui.check" class="mr-2 mt-0.5 flex-shrink-0" />
          Strategic consulting and technical advisory
        </li>
      </ul>
    </div>
  </div>
</section>
